import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { DashboardLayout } from "../components/dashboard/DashboardLayout";
import { ClientsPanel } from "../components/dashboard/ClientsPanel";
import { MerchantInfoPanel } from "../components/dashboard/MerchantInfoPanel";
import { StatsPanel } from "../components/dashboard/StatsPanel";
import { MarketingKitPanel } from "../components/dashboard/MarketingKitPanel";
import { api } from "../lib/api";

export default function Commercant() {
  const { user, loading, logout } = useAuth();
  const [active, setActive] = useState("clients");
  const [merchantName, setMerchantName] = useState("");
  const [merchantId, setMerchantId] = useState("");

  useEffect(() => {
    if (user?.role === "commercant") {
      api.get("/me/merchant").then(({ data }) => { setMerchantName(data.nom); setMerchantId(data.id); }).catch(() => {});
    }
  }, [user]);

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "commercant") return <Navigate to="/" replace />;

  const sections = [
    { id: "clients",   label: "Mes clients",       content: <ClientsPanel /> },
    { id: "merchants", label: "Mes infos",         content: <MerchantInfoPanel /> },
    { id: "kit",       label: "Mon kit marketing", content: <MarketingKitPanel merchantId={merchantId || "self"} allowSelector={false} /> },
    { id: "stats",     label: "Statistiques",      content: <StatsPanel /> },
  ];

  return (
    <DashboardLayout
      user={user}
      sections={sections}
      active={active}
      onChange={setActive}
      onLogout={logout}
      subtitle={`Commerçant${merchantName ? ` · ${merchantName}` : ""}`}
    />
  );
}
